var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V7l8 5 8-5v5h2V5c0-1.1-.9-2-2-2m-8 7L4 5h16zm7 4 4 4-4 4v-3h-4v-2h4z"
  })));
};
export default SvgEmail;